export default {
  giftcard: {
    endpoints: {
      balance: "https://australia-southeast1-effortless-fort-408106.cloudfunctions.net/giftCardVii",
    },
  },
  mapbox: {
    accessToken: "pk.eyJ1IjoiYnJ1bmFkaWFzbnciLCJhIjoiY21hYnpzZXAwMWEzdjJrbzY5bnAybGNmbSJ9.EmjHeJqkXf_3b9T0Wp_xUQ",
  },
};
